import axios from 'axios';

const isProduction = process.env.NODE_ENV === 'production';
const BASE_URL = process.env.REACT_APP_API_URL || (isProduction ? '' : 'http://localhost:3001');
// Garantir que a URL termina com /api/ para todas as chamadas
const API_URL = BASE_URL.replace(/\/$/, '') + '/api/';




const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para adicionar Token JWT
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('nexo_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor para tratar erros globais (ex: 401)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('nexo_token');
            // Redirecionar para login se não estiver em uma rota pública
            if (!window.location.pathname.includes('/login') && !window.location.pathname.includes('/registrar')) {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
